import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["highlight"]
  static values = {
    targetId: String,
    skip: Boolean,
    highlightClasses: { type: String, default: "ring-2 ring-warning/50 bg-warning/15" },
    duration: { type: Number, default: 2500 },
    scrollBehavior: { type: String, default: "smooth" },
    scrollBlock: { type: String, default: "center" }
  }

  connect() {
    if (this.skipValue) return
    if (window.location.hash !== `#${this.anchorId}`) return

    requestAnimationFrame(() => {
      this.element.scrollIntoView({ behavior: this.scrollBehaviorValue, block: this.scrollBlockValue })
      this.highlightTarget.classList.add(...this.highlightClassList)

      window.setTimeout(() => {
        this.highlightTarget.classList.remove(...this.highlightClassList)
      }, this.durationValue)
    })
  }

  get anchorId() {
    return this.targetIdValue || this.element.id
  }

  get highlightClassList() {
    return this.highlightClassesValue.split(/\s+/).filter(Boolean)
  }
}
